import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { useContractActions } from 'commerce-contract-lib/features/actions/hooks/useContractActions';
import { useSubscription } from 'commerce-subscription-lib/public/hooks';
import { CONTRACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import PortalIdParser from 'PortalIdParser';
import { useHasContractM2Gate } from '../../hooks/useHasGate';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function getContractRecordUrl(contractId) {
  return `/contacts/${PortalIdParser.get()}/record/0-721/${contractId}`;
}
export function ContractManagedAlert() {
  const subscription = useSubscription();
  const contractId = subscription === null || subscription === void 0 ? void 0 : subscription.contractId;
  const {
    CREATE_CHANGE_QUOTE
  } = useContractActions({
    objectId: contractId !== null && contractId !== void 0 ? contractId : -1,
    objectTypeId: CONTRACT_TYPE_ID
  });
  const hasContractM2Gates = useHasContractM2Gate();
  return /*#__PURE__*/_jsxs(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "subscriptions.Actions.contractManaged.title"
    }),
    children: [/*#__PURE__*/_jsx(Text, {
      children: hasContractM2Gates ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.Actions.contractManaged.body"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "subscriptions.Actions.contractManaged.bodyNoChangeQuote"
      })
    }), /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "view-contract-button",
        children: /*#__PURE__*/_jsx(Link, {
          href: getContractRecordUrl(contractId),
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.Actions.contractManaged.viewContract"
          })
        })
      }), contractId && (CREATE_CHANGE_QUOTE === null || CREATE_CHANGE_QUOTE === void 0 ? void 0 : CREATE_CHANGE_QUOTE.isValid()) && hasContractM2Gates && /*#__PURE__*/_jsx(Button, {
        "data-test-id": "create-change-quote-button",
        children: /*#__PURE__*/_jsx(Link, {
          onClick: CREATE_CHANGE_QUOTE.onClick,
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.Actions.contractManaged.createChangeQuote"
          })
        })
      })]
    })]
  });
}